module.exports = __webpack_public_path__ + "static/media/AU-Monash.01e9c04a.png";